import { Component, Input, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-edit-credit-trip",
  templateUrl: "./edit-credit-trip.component.html",
  styleUrls: ["./edit-credit-trip.component.css"],
})
export class EditCreditTripComponent implements OnInit {
  loading: boolean = false;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  editCreditForm: FormGroup;
  token: any;
  creditData: any;
  driverData: any;

  constructor(
    private matdialogref: MatDialogRef<EditCreditTripComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formbuilder: FormBuilder,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.driverData = this.data;
    this.token = sessionStorage.getItem("to_token");
    this.editCreditForm = this.formbuilder.group({
      truck_number: [""],
      username: [""],
      mobile: [""],
      loading_point: [""],
      unloading_point: [""],
      price_per_ton: [""],
      sales_order_number: [""],
      lr_number: [""],
      lr_date: [""],
      tax_invoice_no: [""],
      ddc_no: [""],
    });
    this.maxDate.setDate(this.maxDate.getDate() + 0);
  }

  validateTaxInvoiceInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    const pattern = /^[a-zA-Z0-9/-]*$/;
    if (!pattern.test(charStr)) {
      event.preventDefault();
    }
  }

  close() {
    this.matdialogref.close();
  }
  updateTrip() {
    let sales = this.editCreditForm.value.sales_order_number;
    if (!sales) {
      this.snackBar.open("Please enter sales order number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lr = this.editCreditForm.value.lr_number;
    if (!lr) {
      this.snackBar.open("Please enter lr number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lrDate = this.editCreditForm.value.lr_date;
    if (!lrDate) {
      this.snackBar.open("Please select lr date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let tax = this.editCreditForm.value.tax_invoice_no;
    if (!tax) {
      this.snackBar.open("Please enter tax invoice number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let ddc = this.editCreditForm.value.sales_order_number;
    if (!ddc) {
      this.snackBar.open("Please enter ddc number", "Fail", {
        duration: 5000,
      });
      return;
    }

    const updateTripObj = {
      other_details: {
        loading_point: Number(this.editCreditForm.value.loading_point),
        unloading_point: Number(this.editCreditForm.value.unloading_point),
        price_per_ton: Number(this.editCreditForm.value.price_per_ton),
        sales_order_number: this.editCreditForm.value.sales_order_number,
        lr_number: this.editCreditForm.value.lr_number,
        lr_date: this.editCreditForm.value.lr_date,
        tax_invoice_no: this.editCreditForm.value.tax_invoice_no,
        ddc_no: this.editCreditForm.value.ddc_no,
      },
    };
    this.services
      .updateCreditTrip(updateTripObj, this.creditData._id, this.token)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.matdialogref.close();
            this.snackBar.open(response.body.message, "Success", {
              duration: 5000,
            });
          }
        },
        (error) => {
          if (error.status == 403 || 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed || jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
